<template>
  <div class="app flex-row align-items-center bg-black">
    <!-- Browsers block speechSynthesis until the page has had a user gesture -
         this kiosk is left running all day with no interaction, so show a
         one-time full-screen prompt to unlock sound instead of silently
         never announcing anything. -->
    <div v-if="!soundEnabled" class="sound-unlock-overlay" @click="enableSound">
      <div class="text-center color-white">
        <i class="fas fa-volume-up font-24 mb-15"></i>
        <div class="font-bold font-15">Klik untuk mengaktifkan suara</div>
      </div>
    </div>
    <div class="container-fluid">
      <b-row class="justify-content-center scan-box">
        <b-col sm="10" lg="8">
          <div class="text-center mb-15">
            <img class="mb-20 logo-scan" :src="`/logo2.svg`">
            <div class="font-bold color-white">Welcome to PARADIGM ! (DS)</div>
            <div class="color-white">{{ realtime }}</div>
          </div>
          <div class="p-30 box-scan color-white">
            <div class="row">
              <div class="col-md-4">
                <img class="w-100" :src="parseImg(dataMember)" alt="">
                <div class="detail text-center mt-15">
                  <div class="font-700 font-15">{{ dataMember.first_name }} {{ dataMember.last_name }}</div>
                  <div>ID {{ dataMember.branch && dataMember.branch.codename ? dataMember.branch.codename :
                    '-' }}-{{ dataMember.id }}</div>
                  <div>Birthday {{ dataMember.birthday }}</div>
                </div>
                <div class="detail2 text-center mt-15">
                  <div>Join, {{ dataMember.start_membership }}</div>
                  <div class="font-700">Expired, {{ dataMember.membership_expired_date }}</div>
                </div>
                <!-- <div class="detail2 text-center mt-15">
                      <div class="font-700" style="color:red;">Status, {{dataMember.membership_status ? dataMember.membership_status.name : '-'}}</div>
                    </div> -->
              </div>
              <div class="col-md-8">
                <table class="mb-20">
                  <tr>
                    <td><span class="mr-10 text-16-bold">Type Membership</span></td>
                    <td><span class="mr-10 text-16-bold">:</span> <span class="text-16-bold">{{ dataMember.membership ?
                      dataMember.membership.name : '-' }}</span></td>
                  </tr>
                  <tr>
                    <td><span class="mr-10 text-16-bold">Total Outstanding (Price)</span></td>
                    <td>
                      <span class="mr-10 text-16-bold">:</span> <span class="text-16-bold">{{
                        outstanding.outstanding_price ?
                          parseCurrency(outstanding.outstanding_price) : '-'}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td><span class="mr-10 text-16-bold">Manual Attend</span></td>
                    <td>
                      <span class="mr-10 text-16-bold">:</span> <span class="text-16-bold">{{
                        dataMember.gym_attend_manual_count }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td><span class="mr-10 text-16-bold">Branch</span></td>
                    <td>
                      <span class="mr-10 text-16-bold">:</span> <span class="text-16-bold">{{ dataMember.branch ?
                        dataMember.branch.name : '-' }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td><span class="mr-10 text-16-bold">Towel</span></td>
                    <td>
                      <span class="mr-10 text-16-bold">:</span> <span class="text-16-bold">{{ towel != '' ? towel :
                        '-' }}</span>
                    </td>
                  </tr>
                  <tr>
                    <!-- <td><span class="mr-10">Status</span></td> -->
                    <!-- <td><span class="mr-10">:</span><span class="color-red text-uppercase">{{dataMember.membership_status ? dataMember.membership_status.name : '-'}}</span></td> -->
                  </tr>
                </table>
                <table>
                  <tr>
                    <td class="p-5">
                      <div class="mb-3">
                        <div class="detail2 text-start mt-15">
                          <div class="font-700">Status,
                            <template v-if="dataMember.membership_status">
                              <template v-if="dataMember.membership_status.name == 'Active'">
                                <span style="font-size:48px;color: green;">{{ dataMember.membership_status ?
                                  dataMember.membership_status.name : '-'}}</span>
                              </template>
                              <template
                                v-else-if="dataMember.membership_status.name == 'Cancelling' || dataMember.membership_status.name == 'Cancelled'">
                                <span style="font-size:48px;color: red;">{{ dataMember.membership_status ?
                                  dataMember.membership_status.name : '-'}}</span>
                              </template>
                              <template v-else>
                                <span style="font-size:48px;color: yellow;">{{ dataMember.membership_status ?
                                  dataMember.membership_status.name : '-'}}</span>
                              </template>
                            </template>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style="width: 20%;"></td>
                    <td class="p-5">
                      <div class="mb-3">
                        <div class="detail2 text-start mt-15">
                          <div class="font-700">Status Payment,
                            <span style="font-size:28px">{{ dataMember.payment_status ? dataMember.payment_status.name :
                              '-' }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
                <div class="mb-5">Today’s Class</div>
                <template v-for="(item, index) in scheduleClasses">
                  <div v-if="(item.classes_schedule ? item.classes_schedule.member_next_schedule : '') === 'yes'"
                    :key="index">
                    <div class="font-700 font-15 mb-5">{{ item.classes_schedule ? item.classes_schedule.class.name :
                      '-' }}</div>
                    <div class="mb-5">{{ stringCut(item.classes_schedule && item.classes_schedule.classes_time ?
                      item.classes_schedule.classes_time.time_start : '-') }} - {{ stringCut(item.classes_schedule &&
                        item.classes_schedule.classes_time ? item.classes_schedule.classes_time.time_end : '') }}</div>
                    <div>{{ item.classes_schedule && item.classes_schedule.studio ? item.classes_schedule.studio.name :
                      '-' }}</div>
                  </div>
                </template>
                <div class="mt-30">
                  <div class="title mb-10">Your Schedule</div>
                  <div class="table-schedule">
                    <table class="w-100">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Class</th>
                          <th>Studio</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in scheduleClasses" :key="item.id"
                          :class="((item.classes_schedule ? item.classes_schedule.member_next_schedule : '') === 'yes') ? 'schedule-row-active' : ''">
                          <td>{{ parseDate(item.class_date) }}</td>
                          <td>{{ stringCut(item.classes_schedule && item.classes_schedule.classes_time ?
                            item.classes_schedule.classes_time.time_start : '') }} - {{ stringCut(item.classes_schedule
                              &&
                              item.classes_schedule.classes_time ? item.classes_schedule.classes_time.time_end : '')}}
                          </td>
                          <td>{{ item.classes_schedule ? item.classes_schedule.class.name : '-' }}</td>
                          <td>{{ item.classes_schedule ? item.classes_schedule.studio.name : '-' }}</td>
                          <td>{{ item.classes_schedule ? item.classes_schedule.attend_status : '-' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="mt-30">
                  <div class="title mb-10">Outstanding History</div>
                  <div class="table-schedule">
                    <table class="w-100">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Payment Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in outstandingHistory" :key="item.id">
                          <td>{{ parseDate(item.outstanding_date) }}</td>
                          <td>{{ parseCurrency(item.amount) }}</td>
                          <td>{{ item.classes_schedule == 1 ? "Success" : "Failed" }}</td>
                          <td>{{ item.payment_date ? parseDate(item.payment_date) : '-' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Status Agreement -->
                <div class="mt-30">
                  <div class="title mb-10">Agreement Status</div>
                  <table class="mb-20">
                    <tr>
                      <td><span class="mr-10">Membership</span></td>
                      <td><span class="mr-10">:</span>{{ membership_agreement ? membership_agreement : '-' }}</td>
                    </tr>
                    <tr>
                      <td><span class="mr-10">PT Session</span></td>
                      <td><span class="mr-10">:</span>{{ pt_session_agreement.is_agree ? pt_session_agreement.is_agree :
                        '-' }}</td>
                    </tr>
                    <tr>
                      <td><span class="mr-10"></span></td>
                      <td><span class="mr-10">:</span>{{ pt_session_agreement.is_agree ? pt_session_agreement.is_agree :
                        `(PT name)` }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.sound-unlock-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>

<script>
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'Scan',
  data: () => ({
    dataMember: [],
    outstanding: [],
    attendStatusToday: [],
    classesToday: [],
    studioToday: [],
    classesTimeToday: [],
    scheduleClasses: [],
    outstandingHistory: [],
    realtime: '',
    loginData: {
      email: '',
      password: ''
    },
    membership_agreement: '',
    pt_session_agreement: {
      is_agree: '',
      pt_name: ''
    },
    towel: '',
    soundEnabled: false
  }),
  methods: {
    stringCut(event) {
      return event.substring(0, 5)
    },
    parseImg(value) {
      const baseLeadUrl = 'https://api.paradigmfitnessindonesia.com/crm/v1/img/leads/'
      const img = value.lead ? value.lead.selfie_photo ?  baseLeadUrl + value.lead.selfie_photo : Auth.apiUrl + 'fitness/v1/img/member/' + value.thumbnail : Auth.apiUrl + 'fitness/v1/img/member/' + value.thumbnail
      return img
    },
    parseDate(value) {
      moment.locale('en')
      return moment(value).format('dddd, DD MMMM YYYY')
    },
    parseCurrency(event) {
      var data = parseFloat(event)
      return 'Rp. ' + data.toLocaleString('id-ID', { maximumFractionDigits: 2 })
    },
    // One-time unlock for the browser's autoplay/speech restriction - this
    // kiosk is left open unattended all day, so the click only ever happens
    // once when a staff member starts the monitor for the day.
    enableSound() {
      this.soundEnabled = true
      if (window.speechSynthesis) {
        // empty utterance just to get the engine "warmed up" on this click
        window.speechSynthesis.speak(new SpeechSynthesisUtterance(''))
      }
    },
    speakWelcome(member) {
      if (!this.soundEnabled || !window.speechSynthesis || !member) return

      const name = `${member.first_name || ''} ${member.last_name || ''}`.trim()
      const status = member.membership_status ? member.membership_status.name : ''
      if (!name) return

      const text = status
        ? `Selamat datang, ${name}. Status membership ${status}`
        : `Selamat datang, ${name}`

      // Cancel whatever is still being announced so a new scan is always
      // heard immediately instead of queueing up behind older ones.
      window.speechSynthesis.cancel()

      const utterance = new SpeechSynthesisUtterance(text)
      utterance.lang = 'id-ID'
      window.speechSynthesis.speak(utterance)
    },
    // fetchData () {
    //   axios.get('fitness/v1/scanning/member_schedule/' + '188056c68fbea3718878404d5144280e4fe05776f4').then(response => {
    //     this.dataMember = response.data.member
    //     this.attendStatusToday = response.data.member_class_schedule[0].classes_schedule.attend_status
    //     this.classesToday = response.data.member_class_schedule[0].classes_schedule.class.name
    //     this.studioToday = response.data.member_class_schedule[0].classes_schedule.studio.name
    //     this.classesTimeToday = (response.data.member_class_schedule[0].classes_schedule.classes_time.time_start).substring(0, 5) + ' - ' + (response.data.member_class_schedule[0].classes_schedule.classes_time.time_end).substring(0, 5)
    //     this.scheduleClasses = response.data.member_class_schedule
    //     // console.log('test', response.data.data.rows)
    //   }).catch(error => {
    //     console.log('error', error)
    //   })
    // }
  },
  sockets: {
    message: function (data) {
      console.log('Socket Connected', data)
    },
    gym_attendance_dr: function (event) {
      this.dataMember = []
      this.attendStatusToday = []
      this.classesToday = []
      this.studioToday = []
      this.classesTimeToday = []
      this.scheduleClasses = []
      this.outstandingHistory = []
      this.outstanding = event
      this.dataMember = event.member
      this.membership_agreement = event.membership_agreement
      this.pt_session_agreement = event.pt_session_agreement
      // this.attendStatusToday = event.member_class_schedule && event.member_class_schedule[0].classes_schedule ? event.member_class_schedule[0].classes_schedule.attend_status : '-'
      // this.classesToday = event.member_class_schedule && event.member_class_schedule[0].classes_schedule ? event.member_class_schedule[0].classes_schedule.class.name : '-'
      // this.studioToday = event.member_class_schedule && event.member_class_schedule[0].classes_schedule ? event.member_class_schedule[0].classes_schedule.studio.name : '-'
      // this.classesTimeToday = event.member_class_schedule && event.member_class_schedule[0].classes_schedule ? ((event.member_class_schedule[0].classes_schedule.classes_time.time_start).substring(0, 5) + ' - ' + (event.member_class_schedule[0].classes_schedule.classes_time.time_end).substring(0, 5)) : '-'
      this.scheduleClasses = event.member_class_schedule
      this.outstandingHistory = event.due_payment
      this.towel = event.member_towel

      this.speakWelcome(event.member)
    }
  },
  created() {
    this.$socket.emit('echo', { msg: 'Success Connected Darmawangsa' })
  }
}
</script>
